import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  getWishlistAPI,
  removeWishlistAPI,
} from '../services/api';
import {
  loadWishlistIds,
  saveWishlistIds,
  getUserIdFromLocalStorage,
} from '../utils/localWishlist';
import { getProducts } from '../services/api';
import './Wishlist.css';

function isLoggedIn() {
  return !!localStorage.getItem('access_token');
}

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function run() {
      try {
        setLoading(true);

        if (isLoggedIn()) {
          /* Logged-in: fetch from API */
          const res = await getWishlistAPI();
          setItems(res.data.items || []);
        } else {
          /* Guest: fetch products and filter by localStorage IDs */
          const ids = loadWishlistIds(getUserIdFromLocalStorage());
          if (ids.length === 0) {
            setItems([]);
            return;
          }
          const prodRes = await getProducts();
          const all = Array.isArray(prodRes.data)
            ? prodRes.data
            : prodRes.data?.results || [];
          setItems(all.filter((p) => ids.includes(p.id)));
        }
      } catch (e) {
        setItems([]);
      } finally {
        setLoading(false);
      }
    }
    run();
  }, []);

  const remove = async (item) => {
    if (isLoggedIn()) {
      try {
        const res = await removeWishlistAPI(item.product_id);
        setItems(res.data.items || []);
      } catch (e) {}
      return;
    }
    /* Guest */
    const userId = getUserIdFromLocalStorage();
    const ids = loadWishlistIds(userId).filter((id) => id !== (item.id || item.product_id));
    saveWishlistIds(userId, ids);
    setItems((prev) => prev.filter((p) => (p.id || p.product_id) !== (item.id || item.product_id)));
  };

  if (loading) {
    return (
      <div className="wishlist-page">
        <h2>Your Wishlist</h2>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="wishlist-page">
      <div className="wishlist-header">
        <h2>Your Wishlist</h2>
      </div>

      {items.length === 0 ? (
        <div className="wishlist-empty">
          <p>No wishlist items yet.</p>
          <Link className="wishlist-continue" to="/shop">Browse products</Link>
        </div>
      ) : (
        <div className="wishlist-grid">
          {items.map((item) => {
            const id = item.product_id || item.id;
            const name = item.name;
            const brand = item.brand;
            const price = item.price;
            const image = item.image;
            const slug = item.slug;

            return (
              <div key={id} className="wishlist-card">
                <Link to={`/product/${slug}`} className="wishlist-card-link">
                  <img
                    className="wishlist-img"
                    src={image || '/placeholder.jpg'}
                    alt={name}
                  />
                  <div className="wishlist-meta">
                    <div className="wishlist-name">{name}</div>
                    <div className="wishlist-brand">{brand}</div>
                    <div className="wishlist-price">₹{price}</div>
                  </div>
                </Link>

                <button
                  className="wishlist-remove"
                  onClick={() => remove(item)}
                >
                  Remove
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}